import React, { useEffect } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../../../Pagination";

const DeletedCorier = ({
  tableRef,
  onMouseDown,
  corierDeletedRows,
  softDeleteRestoreStudyCorierRow,
  Show,
  Hide,
  Title,
  getDeletedStudyCorierRowData,
  corierDeletedRowsCount,
  pageNumberDeleted,
  itemsPerPageDeleted,
  setPageNumberDeleted,
  setItemsPerPageDeleted,
}) => {
  const startIndex = (pageNumberDeleted - 1) * itemsPerPageDeleted;
  const totalPage = Math.ceil(corierDeletedRowsCount / itemsPerPageDeleted);
  useEffect(() => {
    getDeletedStudyCorierRowData(pageNumberDeleted, itemsPerPageDeleted);
  }, [pageNumberDeleted, itemsPerPageDeleted]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {corierDeletedRows?.length === 0 ? (
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 44px)" }}
            >
              <NoDataFoundTable MSG={"Coriers not deleted yet."} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Corier Id</th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 2)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {corierDeletedRows?.map((row, index) => (
                    <tr key={index} title="View Details">
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td>{row?.row?.["CORIERID"]}</td>
                      <td className="text-center" title="Restore">
                        <MdRestore
                          style={{ fontSize: 16 }}
                          onClick={(e) =>
                            softDeleteRestoreStudyCorierRow(
                              row?._id,
                              "restore"
                            )
                          }
                          className="text-success CP"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumberDeleted}
                  itemsPerPage={itemsPerPageDeleted}
                  totalItems={corierDeletedRowsCount}
                  setPageNumber={setPageNumberDeleted}
                  setItemsPerPage={setItemsPerPageDeleted}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedCorier;
